import React, { useState, useEffect, useRef } from 'react';
import { apiClient } from '../../../api';
import { token } from '../../../config';
import NewsDesktop from './components/NewsDesktop';
import { Col, Row, Spin } from 'antd';
import "./components/Home.scoped.scss"
import { ArrowUpRight } from "lucide-react"
import NewsMobile from './components/NewsMobile';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';


function useIsMobile(breakpoint = 768) {
    const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);

    useEffect(() => {
        const mediaQuery = window.matchMedia(`(max-width: ${breakpoint}px)`);

        const handleChange = (e) => {
            setIsMobile(e.matches);
        };

        mediaQuery.addEventListener("change", handleChange);
        return () => mediaQuery.removeEventListener("change", handleChange);
    }, [breakpoint]);

    return isMobile;
}

function Home() {
    const [index, setIndex] = useState(0);
    const [announcement, setAnnouncement] = useState([])
    const [news, setNews] = useState([])
    const [modalNews, setModalNews] = useState({})
    const [modalBanner, setModalBanner] = useState({})
    const [currentIndex, setCurrentIndex] = useState(0)
    const [loading, setLoading] = useState(true)
    const timeoutRef = useRef(null);
    const intervalRef = useRef(null);
    const isMobile = useIsMobile();
    const history = useHistory();

    const openNewsModal = (value) => {
        setModalNews(value)
    }

    const openBannerModal = (value) => {
        setModalBanner(value)
    }
    const resetTimeout = () => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };

    useEffect(() => {
        intervalRef.current = setInterval(() => {
            setIndex((prev) => (prev + 1) % announcement.length);
        }, 5000);

        return () => {
            clearInterval(intervalRef.current);
        };
    }, [announcement.length]);

    const goToPrev = () => {
        setIndex((index - 1 + announcement.length) % announcement.length);
    };

    const goToNext = () => {
        setIndex((index + 1) % announcement.length);
    };

    const handleNavigate = (type, id) => {
        history.push("/News-Announcement-detail", {
            type: type,
            id: id,
            announcement: announcement,
            news: news
        });
    }

    const handleGetNewsAndAnnouncement = () => {
        apiClient.get('api/Announcement/home', {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-type': 'application/json; charset=UTF-8'
            }
        })
            .then(result => {
                setNews(result.data?.Banners || [])
                setAnnouncement(result.data?.News || [])
                setLoading(false)
            })
    }

    useEffect(() => {
        handleGetNewsAndAnnouncement();
    }, [])


    const isCustomImage = (icon) =>
        icon === "Ants_LINEOA" ||
        icon === "Ants_LON" ||
        icon === "Ants_MMS" ||
        icon === "Ants_SMS";


    const total = news?.length;

    const nextSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % total);
    };

    const prevSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + total) % total);
    };

    return (
        <Spin spinning={loading}>
            <div className='containner' style={{ margin: '20px 48px 20px 32px' }}>
                <div className='container-row'>
                    <div className='banner-container'>
                        {isMobile ?
                            <NewsMobile
                                news={news}
                                handleNavigate={handleNavigate}
                                isCustomImage={isCustomImage}
                                currentIndex={currentIndex}
                                nextSlide={nextSlide}
                                prevSlide={prevSlide}
                                setLoading={setLoading}
                            />
                            : <NewsDesktop
                                news={news}
                                handleNavigate={handleNavigate}
                                isCustomImage={isCustomImage}
                                currentIndex={currentIndex}
                                nextSlide={nextSlide}
                                prevSlide={prevSlide}
                                total={total}
                                setLoading={setLoading}
                            />
                        }
                    </div>
                    <div className='d-flex flex-column w-100' style={{height: '90vh'}}>
                        {isMobile ? (
                            <h1>Announcement</h1>
                        ) : (
                            <>
                                <div className='d-flex align-items-center news-header'>
                                    <i className="fas fa-angle-double-left mr-3" size="lg" style={{ color: "#19164F" }}></i>
                                    <h2>News</h2>
                                </div>
                                <div className='d-flex align-items-center justify-content-end announcement-header'>
                                    <h2>Announcement</h2>
                                    <i className="fas fa-angle-double-down ml-3" size="lg" style={{ color: "#19164F" }}></i>
                                </div>
                            </>
                        )}

                        {announcement?.length == 0 ? (
                            <div
                                className='w-100 bg-home d-flex justify-content-center align-items-center flex-column'
                                style={{ height: '65vh', borderRadius: "32px" }}
                            >
                                <h1 className='text-secondary text-center'>Please stay tuned for the</h1>
                                <h1 className='text-secondary text-center'>announcement soon.</h1>
                            </div>
                        ) : (
                            <div className="announcement-container"
                                style={{ height: '580px', borderRadius: "32px", overflowY: 'auto' }}
                            >
                                <div className="announcement-list">
                                    {announcement.map((item, index) => (
                                        <div key={item.Id} className="announcement-item" onClick={() => handleNavigate(item.Type, item.Id)}>
                                            <div className="announcement-number">{String(index + 1).padStart(2, "0")}</div>
                                            <img className="announcement-avatar" src={`/img/vendors/icon/${item.IconUrl || '1'}.png`} />
                                            <div className="announcement-content">
                                                <h3 className="announcement-title">{item.Topic}</h3>
                                                <p className="announcement-subtitle">{item.SubTopic}</p>
                                            </div>
                                            <div className="announcement-arrow">
                                                <ArrowUpRight className="arrow-icon" />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                    </div>
                </div>
            </div>
        </Spin>

    )
}

export default Home